// Shared helpers for the BOM editor.
export const yen = (n) => '¥' + Number(n || 0).toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo' });

export function flattenTree(node, depth, acc) {
  acc.push({ node, depth });
  (node.children || []).forEach((c) => flattenTree(c, depth + 1, acc));
  return acc;
}

// 部品行の表示用メタ情報: BOM取得値 → 選択時の品目情報 → 品目キャッシュ の順で解決
export const metaFor = (c, items) => {
  const it = items.find((x) => x.id === c.component_item_id) || {};
  const m = { ...it };
  Object.entries(c).forEach(([k, v]) => { if (v != null && v !== '') m[k] = v; });
  return m;
};

export const unitCostOf = (m) => (m.unit_cost != null ? m.unit_cost
  : ((m.processing_type === 'subcontracted' && m.subcontract_unit_price != null) ? m.subcontract_unit_price : (m.cost || 0)));
